export default __webpack_public_path__ + "static/media/Subtract.c1f3b276.svg";